import React from "react";
import BoxLoader from "../commons/BoxLoader/BoxLoader";
import { ScheduleJobIcon, ViewAllIcon } from "../../assets/images";

type AppProps = {
  data: any;
  history: any;
  userId?: number | null;
  name?: string;
  fetching: boolean;
};

const LoggedInUsersScheduledJob = ({
  data,
  history,
  userId,
  name,
  fetching,
}: AppProps) => {
  return (
    <div className="boxs w-100 pt-3 pb-3 pl-2 pr-2" style={{ height: "125px"}}>
      {fetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div style={{display:"flex", gap:"14px", alignItems:"center", marginTop:"10px"}}>
            <img src={ScheduleJobIcon} alt="schedule Job Icon" style={{width:'69px'}}/>
            <div>
            <span className="boxs-container-heading">Your Scheduled Jobs</span>
            <div className="">
            <div style={{ display: "flex", alignItems: "center", gap:"15px" }}>
              <div style={{ fontSize: "35px", fontWeight: 500 }}>
                {data?.length}
              </div>
              <div
                style={{ color: "#dd4433", cursor: "pointer" }}
                onClick={() => {
                  history.push({
                    pathname: `scheduling/user`,
                    state: {
                      userId,
                      name,
                    },
                  });
                }}
              >
              <img src={ViewAllIcon} alt="View All Icon"/>
              </div>
            </div>
          </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LoggedInUsersScheduledJob;
